function initializeCollectionLogic() {
    const filterForm = document.getElementById('CollectionFilterForm');
    const sortBySelect = document.getElementById('SortBy');
    const productContainer = document.getElementById('product-grid');
    const toggleContainer = document.getElementById('CollectionMobileViewToggle');
    const buttons = toggleContainer ? toggleContainer.querySelectorAll('.view-toggle-btn') : [];

    // ------------------------------------------------------------------------
    // A. MANUAL FILTER FORM SUBMISSION LOGIC
    // Submits the form when a filter checkbox is changed.
    // ------------------------------------------------------------------------

    if (filterForm) {
        const checkboxes = filterForm.querySelectorAll('input[type="checkbox"][name="tag"]');
        
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                // Get all checked tags
                const checkedTags = Array.from(filterForm.querySelectorAll('input[type="checkbox"][name="tag"]:checked'))
                                       .map(input => input.value);
                
                // Construct the new URL path
                let newPath = filterForm.getAttribute('action');
                
                if (checkedTags.length > 0) {
                    // Shopify's collection filtering uses a comma-separated list of tags
                    const tagsSegment = checkedTags.map(tag => encodeURIComponent(tag)).join('+');
                    
                    // The path changes from /collections/handle to /collections/handle/tag1+tag2
                    newPath = `${newPath}/${tagsSegment}`;
                }

                // Preserve existing query parameters (like sorting)
                const currentSearchParams = new URLSearchParams(window.location.search);
                currentSearchParams.delete('tag'); // Remove old tag parameter
                
                let queryString = currentSearchParams.toString();
                if (queryString) {
                    newPath = `${newPath}?${queryString}`;
                }

                // Navigate to the new URL
                window.location.href = newPath;
            });
        });
    }

    // ------------------------------------------------------------------------
    // B. MANUAL SORTING LOGIC
    // Submits a change to the URL's sort_by parameter.
    // ------------------------------------------------------------------------

    if (sortBySelect) {
        sortBySelect.addEventListener('change', function() {
            const newSortBy = this.value;
            const currentUrl = new URL(window.location.href);
            
            // Add or replace the 'sort_by' parameter
            currentUrl.searchParams.set('sort_by', newSortBy);

            // Navigate to the new URL
            window.location.href = currentUrl.toString();
        });
    }


    // ------------------------------------------------------------------------
    // C. MOBILE LIST/GRID VIEW TOGGLE LOGIC (from previous step)
    // ------------------------------------------------------------------------
    
    // Check if the current screen width is mobile (match CSS breakpoint)
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (!isMobile || !productContainer || buttons.length === 0) {
        return; 
    }

    // 1. Retrieve saved preference (default to 'grid')
    const savedView = localStorage.getItem('mobile_collection_view') || 'grid';

    // 2. Apply the saved view on page load
    productContainer.classList.add(`${savedView}-view`);
    
    buttons.forEach(btn => {
        // Set the initial active button state
        btn.classList.toggle('active', btn.dataset.view === savedView);

        // Add click listener
        btn.addEventListener('click', function() {
            const newView = this.dataset.view;

            // Toggle active button state
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            // Apply the new view class to the product container
            productContainer.classList.remove('grid-view', 'list-view');
            productContainer.classList.add(`${newView}-view`);

            // 3. Save preference to local storage
            localStorage.setItem('mobile_collection_view', newView);

            if(newView == 'grid') {
                productContainer.querySelector('.grid.product-grid').classList.remove('grid--1-col-tablet-down');
                productContainer.querySelector('.grid.product-grid').classList.add('grid--2-col-tablet-down');
            }
            else {
                productContainer.querySelector('.grid.product-grid').classList.remove('grid--2-col-tablet-down');
                productContainer.querySelector('.grid.product-grid').classList.add('grid--1-col-tablet-down');
            }
            
            // Trigger a resize event to ensure the theme recalculates layout if necessary
            window.dispatchEvent(new Event('resize')); 
        });
    });
}

// Initialize the function when the page is fully loaded
document.addEventListener('DOMContentLoaded', initializeCollectionLogic);